import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { id: String, type: String, title: String }
  static targets = ["icon"]

  connect() {
    this.updateUI()
  }

  toggle() {
    const key = "boaner_bookmarks"
    let bookmarks = JSON.parse(localStorage.getItem(key) || "[]")
    const item = { id: this.idValue, type: this.typeValue, title: this.titleValue, savedAt: new Date().toISOString() }
    const index = bookmarks.findIndex(b => b.id === this.idValue && b.type === this.typeValue)

    if (index > -1) {
      bookmarks.splice(index, 1)
    } else {
      bookmarks.unshift(item)
    }

    localStorage.setItem(key, JSON.stringify(bookmarks))
    this.updateUI()
  }

  updateUI() {
    const bookmarks = JSON.parse(localStorage.getItem("boaner_bookmarks") || "[]")
    const saved = bookmarks.some(b => b.id === this.idValue && b.type === this.typeValue)

    if (this.hasIconTarget) {
      if (saved) {
        this.iconTarget.innerHTML = '<path fill-rule="evenodd" d="M6.32 2.577a49.255 49.255 0 0111.36 0c1.497.174 2.57 1.46 2.57 2.93V21a.75.75 0 01-1.085.67L12 18.089l-7.165 3.583A.75.75 0 013.75 21V5.507c0-1.47 1.073-2.756 2.57-2.93z" clip-rule="evenodd"/>'
        this.element.classList.add("text-amber-500")
        this.element.classList.remove("text-gray-400")
      } else {
        this.iconTarget.innerHTML = '<path stroke-linecap="round" stroke-linejoin="round" d="M17.593 3.322c1.1.128 1.907 1.077 1.907 2.185V21L12 17.25 4.5 21V5.507c0-1.108.806-2.057 1.907-2.185a48.507 48.507 0 0111.186 0z"/>'
        this.element.classList.remove("text-amber-500")
        this.element.classList.add("text-gray-400")
      }
    }
  }
}
